define('modules/base/modals/modals.controller',[
    "client"
], function(
    Prospector)
{
    Prospector.module("ModalApp.Main", function(Main, Prospector, Backbone, Marionette, $, _, bootstrap){
        Main.Controller = {
            showModal: function(options) {
                $('.modal').empty().append('<div class="modal-dialog"></div>');
                if(options.modalLarge != undefined && options.modalLarge == true){
                    if(!$('.modal-dialog').hasClass('modal-lg')){
                        $('.modal-dialog').addClass('modal-lg')
                    }
                } else {
                    if($('.modal-dialog').hasClass('modal-lg')){
                        $('.modal-dialog').removeClass('modal-lg')
                    }
                }

                if(options.modalFullHeight != undefined && options.modalFullHeight == true){
                    if(!$('.modal-dialog').hasClass('fullHeight')){
                        $('.modal-dialog').addClass('fullHeight')
                    }
                } else {
                    if($('.modal-dialog').hasClass('fullHeight')){
                        $('.modal-dialog').removeClass('fullHeight')
                    }
                }
                $('.modal-dialog').append(options.view.render().el)
                $('.modal').modal();
            }
        }
    });
    return Prospector.ModalApp.Main.Controller;
});
